import { createVNode, render } from 'vue'
import toastTemplate from './index.vue'
var Toast = {};
Toast.install = function(app, options) {
    let opt = {
        position: 'bottom', // 默认显示位置
        type: 'normal',
        duration: 2500, // 持续时间
        value: '',

    }
    for (let property in options) {
        opt[property] = options[property]; // 使用 options 的配置
    }
    app.config.globalProperties.$toast = (tips, type, duration = 0) => {
        opt.value = tips;
        if (type) {
            opt.type = type; // 如果有传type，样式则设为该type
        }

        if (type != 'hide') {
            // 如果toast还在，则清除之前的toast
            clear();
            //创建新的toast
            const container = document.createElement('div')
            container.id = "toast_container";
            const vm = createVNode(toastTemplate, opt) // 创建vNode
            render(vm, container)
            document.body.appendChild(container) // 添加到body上

            if (duration == 0) {
                duration = opt.duration;
            }
            const t = setTimeout(function() {
                clear();
                clearTimeout(t)
            }, duration)
        } else {
            clear();
        }

        function clear() {
            var container = document.getElementById('toast_container');
            if (container) {
                render(null, container)
                document.body.removeChild(container);
            }
        }

    }
}
export default Toast;